import type { ListItemProps as BasicListItemProps } from '@/components/List/ListItem'
import BasicListItem from '@/components/List/ListItem'
import { hideModal, showModal } from '@/components/Modal/utils'
import Page from '@/components/Page'
import Toggle from '@/components/Toggle'
import useUserPreference, { UserPreference } from '@/utils/hooks/useUserPreference'

import { css } from '@emotion/react'
import { Button } from '@ruguoapp/jike-fe-components'
import { StarsOutlineIcon } from '@ruguoapp/jike-fe-icons'
import { createFileRoute } from '@tanstack/react-router'
import type { ReactNode, VideoHTMLAttributes } from 'react'
import { useTitle } from 'react-use'

export const Route = createFileRoute('/experiment')({
	component: ExperimentPage,
})

function ListItem({
	children,
	title,
	feature: featureKey,
	preview,
	...props
}: BasicListItemProps & {
	feature: keyof Pick<UserPreference, 'isActionTextBlurTransitionEffectEnabled'>
	preview?: ReactNode
}) {
	const [isEnabled, setIsEnabled] = useUserPreference(featureKey)

	const handlePreviewClick = () => {
		showModal(title, preview, {
			onClose: () => {
				hideModal()
			},
			lockScroll: false,
		})
	}

	return (
		<BasicListItem
			{...props}
			css={css`
				grid-template-columns: 1fr auto;
			`}
		>
			<div>
				<span>{title}</span>
			</div>

			<div
				css={css`
					display: flex;
					align-items: center;
					gap: 4px;
				`}
			>
				{preview && (
					<Button size="sm" appearance="ghost" onClick={handlePreviewClick}>
						<StarsOutlineIcon
							css={css`
								width: 16px;
								height: 16px;
							`}
						/>
					</Button>
				)}
				<Toggle checked={isEnabled} onChange={() => setIsEnabled((prev) => !prev)} />
			</div>
		</BasicListItem>
	)
}

function FeaturePreviewVideo(props: VideoHTMLAttributes<HTMLVideoElement>) {
	return (
		<video
			width={600}
			css={css`
				max-width: 600px;
				border-radius: 12px;
			`}
			autoPlay
			muted
			loop
			playsInline
			{...props}
		>
			您的浏览器不支持 video 标签。
		</video>
	)
}

function ExperimentPage() {
	useTitle(`🧪 实验室 - 即刻`)

	return (
		<Page title={<>🧪 实验室</>}>
			<div>
				<ListItem
					feature="isActionTextBlurTransitionEffectEnabled"
					title="动态、评论数值模糊变化"
					preview={
						<FeaturePreviewVideo src="https://cdnv2.ruguoapp.com/FqRQw7i6z-v_Ktfguh8rUVNu8j76.mp4" />
					}
				/>
			</div>
		</Page>
	)
}
